export function applyRoleVisibilityToOption(option: any, widgetConfig: any): any {
  if (!option || !widgetConfig) return option;

  const chartConfig = widgetConfig.chartConfig || {};
  const hideAxisLabels = chartConfig.showLabels === false;
  const hideDataLabels =
    hideAxisLabels ||
    chartConfig.showDataLabels === false ||
    chartConfig.showBarLabels === false ||
    chartConfig.showLineLabels === false;
  const hideTooltip = chartConfig.tooltip?.show === false || widgetConfig.tooltip === false;

  if (hideTooltip) {
    applyToCollection(option.tooltip, (tooltip) => {
      tooltip.show = false;
    });
  }

  if (hideAxisLabels) {
    applyToCollection(option.xAxis, hideAxisLabel);
    applyToCollection(option.yAxis, hideAxisLabel);
    applyToCollection(option.angleAxis, hideAxisLabel);
    applyToCollection(option.radiusAxis, hideAxisLabel);
    applyToCollection(option.parallelAxis, hideAxisLabel);
  }

  if (hideDataLabels) {
    applyToCollection(option.series, hideSeriesLabels);
  }

  return option;
}

function applyToCollection(value: any, visitor: (item: any) => void): void {
  if (!value) return;
  if (Array.isArray(value)) {
    value.forEach((item) => item && visitor(item));
    return;
  }
  visitor(value);
}

function hideAxisLabel(axis: any): void {
  axis.axisLabel = { ...(axis.axisLabel || {}), show: false };
}

function hideSeriesLabels(series: any): void {
  hideLabelObject(series);
  hideLabelObject(series.emphasis);
  hideLabelObject(series.blur);
  hideLabelObject(series.select);
  hideLabelObject(series.markPoint);
  hideLabelObject(series.markLine);
  hideLabelObject(series.markArea);
  applyToCollection(series.data, hideLabelObject);
}

function hideLabelObject(target: any): void {
  if (!target || typeof target !== 'object') return;

  if (target.label && typeof target.label === 'object') {
    target.label = { ...target.label, show: false };
  }

  if (target.endLabel && typeof target.endLabel === 'object') {
    target.endLabel = { ...target.endLabel, show: false };
  }

  if (target.labelLine && typeof target.labelLine === 'object') {
    target.labelLine = { ...target.labelLine, show: false };
  }
}
